import React from "react";
import ReactDOM from "react-dom";
import AppRouter from "./routes/router";
import "./index.scss";
import axios from "axios";

// axios.defaults.baseURL = 'https://8zbs3jzavg.execute-api.ap-northeast-1.amazonaws.com/prd';
axios.defaults.baseURL = "https://webapi.ss-sems.net";

ReactDOM.render(
  <React.StrictMode>
    <AppRouter />
  </React.StrictMode>,
  document.getElementById("root")
);
